<template>
  <div class="appds">
    <div
      class="app-web contain-box"
      :style="{ height: contentStyleObj.height }"
      @scroll="onScroll"
    >
      <div class="head" :class="[scrollTop > 0 ? 'bgColor' : '']">
        <div class="contain-box head-box fl-sb-ce">
          <div class="headicon">
            <img src="@/assets/img/headicon.png" alt="" class="headimg" />
          </div>
          <div class="fl-sb-ce">
            <div class="tabsd">
              <el-tabs v-model="tabIndex" @tab-click="jump">
                <el-tab-pane
                  :label="tabs[0].title"
                  v-if="tabs[0].isShow"
                  name="0"
                ></el-tab-pane>
                <el-tab-pane
                  :label="tabs[1].title"
                  v-if="tabs[1].isShow"
                  name="1"
                ></el-tab-pane>
                <el-tab-pane
                  :label="tabs[2].title"
                  v-if="tabs[2].isShow"
                  name="2"
                ></el-tab-pane>
                <el-tab-pane
                  :label="tabs[3].title"
                  v-if="tabs[3].isShow"
                  name="3"
                ></el-tab-pane>
              </el-tabs>
            </div>
          </div>
          <div style="display: flex; align-items: center">
            <img
              class="phone-img"
              src="@/assets/img/icon/Telephone.png"
              alt=""
            />
            <div class="phone-num">质量投诉电话：028-62325607</div>
          </div>
        </div>
      </div>
      <div class="scroll-content">
        <!-- 首页 -->
        <div :ref="tabs[0].refName" class="scroll-item">
          <div class="block">
            <img src="@/assets/img/one.png" alt="" class="imgs" />
          </div>
        </div>
        <!-- 平台介绍 -->
        <div :ref="tabs[1].refName" class="scroll-item">
          <div class="block">
            <img src="@/assets/img/two.png" alt="" class="imgs" />
          </div>
          <div class="block">
            <img src="@/assets/img/three.png" alt="" class="imgs" />
          </div>
          <div class="block">
            <img src="@/assets/img/four.png" alt="" class="imgs" />
          </div>
        </div>
        <!-- 项目解决方案 -->
        <div :ref="tabs[2].refName" class="scroll-item">
          <div class="block">
            <img src="@/assets/img/five.png" alt="" class="imgs" />
          </div>
          <div class="block">
            <img src="@/assets/img/six.png" alt="" class="imgs" />
          </div>
          <div class="block">
            <img src="@/assets/img/seven.png" alt="" class="imgs" />
          </div>
          <div class="block">
            <img src="@/assets/img/eight.png" alt="" class="imgs" />
          </div>
          <div class="block">
            <img src="@/assets/img/nine.png" alt="" class="imgs" />
          </div>
          <div class="block">
            <img src="@/assets/img/ten.png" alt="" class="imgs" />
          </div>
        </div>
        <!-- 联系我们 -->
        <div :ref="tabs[3].refName" class="scroll-item">
          <div class="block">
            <img :src="ImgSrc('eleven.png')" alt="" class="imgs" />
          </div>
          <div class="block setals">
            <div>
              <div class="fxtest">
                <div>
                  药品网络交易第三方平台备案：<span
                    class="xiatext"
                    @click="openImage(1)"
                    >(川)网药平台备字【2023】第000002-000号</span
                  >
                </div>
                <div class="xians"></div>
                <div>
                  预包装食品经营者备案:
                  <span class="xiatext" @click="openImage(2)"
                    >CT(2022)0018</span
                  >
                </div>
                <div class="xians"></div>
                <div>
                  统一社会信用代码：<span class="xiatext" @click="openImage(3)"
                    >91510100MA6CU55E2U</span
                  >
                </div>
              </div>
              <div class="fxtest">
                <div>
                  医疗器械网络交易服务第三方平台备案:
                  <span class="xiatext" @click="openImage(4)">
                    (川)网械平台备字(2020)第00008号</span
                  >
                </div>
                <div class="xians"></div>
                <div>
                  <span class="xiatext" @click="openNew">
                    蜀ICP备20001411号-6</span
                  >
                </div>
              </div>
              <div class="fxtest">
                <div style="cursor: pointer" @click="openNew">
                  <span>Copyright ©2023 四川神鸟世纪科技有限公司</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabIndex: "0",
      contentStyleObj: {
        height: "0",
      },
      scrollTop: 0,
      tabs: [
        {
          isShow: true,
          title: "首页",
          refName: "Homepage",
        },
        {
          isShow: true,
          title: "平台介绍",
          refName: "Platform",
        },
        {
          isShow: true,
          title: "项目解决方案",
          refName: "Mainpro",
        },
        {
          isShow: true,
          title: "联系我们",
          refName: "Contactus",
        },
      ],
    };
  },
  created() {
    this.getDevice();
    window.addEventListener("resize", this.getDevice);
  },
  destroyed() {
    window.removeEventListener("resize", this.getDevice);
  },
  methods: {
    openNew() {
      window.open("https://beian.miit.gov.cn/");
    },
    // tab click
    jump(index) {
      let target = document.querySelector(".app-web");
      let scrollItems = document.querySelectorAll(".scroll-item");
      // 判断滚动条是否滚动到底部
      if (target.scrollHeight <= target.scrollTop + target.clientHeight) {
        this.tabIndex = index.index.toString();
      }
      let totalY =
        scrollItems[index.index].offsetTop - scrollItems[0].offsetTop; // 锚点元素距离其offsetParent(这里是body)顶部的距离(待滚动的距离)
      let distance = document.querySelector(".app-web").scrollTop; // 滚动条距离滚动区域顶部的距离
      // let distance = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset // 滚动条距离滚动区域顶部的距离(滚动区域为窗口)
      // 滚动动画实现, 使用setTimeout的递归实现平滑滚动，将距离细分为50小段，10ms滚动一次
      // 计算每一小段的距离
      let step = totalY / 50;
      if (totalY > distance) {
        smoothDown(document.querySelector(".app-web"));
      } else {
        let newTotal = distance - totalY;
        step = newTotal / 50;
        smoothUp(document.querySelector(".app-web"));
      }
      // 参数element为滚动区域
      function smoothDown(element) {
        if (distance < totalY) {
          distance += step;
          element.scrollTop = distance;
          setTimeout(smoothDown.bind(this, element), 10);
        } else {
          element.scrollTop = totalY - 88;
        }
      }
      // 参数element为滚动区域
      function smoothUp(element) {
        if (distance > totalY) {
          distance -= step;
          element.scrollTop = distance;
          setTimeout(smoothUp.bind(this, element), 10);
        } else {
          element.scrollTop = totalY - 88;
        }
      }
    },
    // 滚动条滚动
    onScroll(e) {
      this.scrollTop = e.target.scrollTop;
      let scrollItems = document.querySelectorAll(".scroll-item");
      for (let i = scrollItems.length - 1; i >= 0; i--) {
        // 判断滚动条滚动距离是否大于当前滚动项可滚动距离
        let judge =
          e.target.scrollTop >=
          scrollItems[i].offsetTop - scrollItems[0].offsetTop - 400;
        if (judge) {
          this.tabIndex = i.toString();
          break;
        }
      }
    },
    // 获取浏览器宽高
    getDevice() {
      this.contentStyleObj.height = window.innerHeight + "px";
    },
    openImage(key) {
      var img = "";
      switch (key) {
        case 1:
          img = require("@/assets/img/药品网络交易第三方平台备案-加水印.png");
          break;
        case 2:
          img = require("@/assets/img/食品备案-加水印.png");
          break;
        case 3:
          img = require("@/assets/img/营业执照副本加水印.png");
          break;
        case 4:
          img = require("@/assets/img/器械备案-加水印.png");
          break;
      }
      window.open(img, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.appds {
  // width: 100%;
  display: flex;
  justify-content: center;
}
/deep/ .el-tabs__nav-wrap::after {
  background-color: #fff;
}
/deep/ .el-tabs__item {
  padding: 0px 50rem;
  font-size: 18rem;
}
/deep/.el-tabs__item:hover {
  color: #1f71ff;
}
/deep/ .el-tabs__item.is-active {
  color: #1f71ff;
}
/deep/ .el-tabs__active-bar {
  background-color: #1f71ff;
}
/deep/ .el-carousel__arrow {
  width: 60rem;
  height: 60rem;
  font-size: 24rem;
}
/deep/ .el-carousel__arrow i {
  font-weight: bold;
}
/deep/ .el-carousel__button {
  width: 45rem;
  height: 4rem;
}
/deep/ .el-tabs__header {
  margin-bottom: 0;
}
/deep/ .el-tabs__nav-wrap::after {
  height: 0;
}
.app-web {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  .head {
    height: 88rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    position: sticky;
    top: 0px;
    z-index: 100;

    .headicon {
      display: flex;
      align-items: center;
      text-align: center;

      .headimg {
        width: 124rem;
        height: 52rem;
      }
    }
    .tabsd {
      display: flex;
      align-items: center;
    }
    .phone-img {
      height: 28rem;
      width: 28rem;
      margin-right: 4rem;
    }
    .phone-num {
      font-size: 18rem;
      color: #1d2129;
    }
  }

  @media (min-width: 640px) and (max-width: 1199px) {
    /deep/ .el-tabs__item {
      padding: 0 12rem;
      font-size: 12rem;
      height: 22rem;
      line-height: 22rem;
    }
    /deep/ .el-tabs__nav {
      display: flex;
      align-items: center;
    }
    .head {
      height: auto;
      .headicon {
        display: flex;
        align-items: center;
        text-align: center;

        .headimg {
          width: 85rem;
          height: auto;
        }
      }
      .phone-img {
        height: 14rem;
        width: 14rem;
        margin-right: 4rem;
      }
      .phone-num {
        font-size: 12rem;
        color: #1d2129;
      }
    }
    .setals {
      background: rgb(245, 248, 250);
      text-align: center;
      font-size: 12rem;
      color: #4e5969;
      padding: 14rem 0;
      line-height: 26rem;
    }
  }
  .bgColor {
    background-color: #fff;
    border-bottom: 1rem solid #eff0f5;
  }
  .scroll-content {
    position: absolute;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    flex: 1;
  }
  .footer {
    width: 100%;
  }
}
.scroll-item {
  width: 100%;
  .block {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    .imgs {
      width: 100%;
      height: 100%;
    }
  }
}
.setals {
  background: rgb(245, 248, 250);
  text-align: center;
  font-size: 14rem;
  color: #4e5969;
  padding: 20rem 0;
  line-height: 30rem;
}

.xiatext {
  text-decoration: underline;
  cursor: pointer;
}
.fxtest {
  display: flex;
  align-items: center;
  justify-content: center;
}
.xians {
  width: 1px;
  height: 12px;
  background: #c9cdd4;
  margin: 0px 15px;
}
</style>
